'use client'

import { Link } from '@/components/ui/link'
import { MainRoutes } from '@/utils/routes'
import { useNavTracking } from './use-nav-tracking'
import { cn } from '@/lib/css-utils'

export function NavSigninButton({ 
  navType,
  isOnDark = false 
}: { 
  navType: 'desktop' | 'mobile'
  isOnDark?: boolean 
}) {
  const { trackNavSigninClick } = useNavTracking()

  return (
    <>
      {navType === 'desktop' && (
        <Link
          href={MainRoutes.Login}
          className={cn('text-sm font-semibold mr-2 text-copy-primary', {
            'text-topNav-link-textDark hover:text-black-100': isOnDark,
          })}
          onClick={trackNavSigninClick}
        >
          Sign In
        </Link>
      )}
      {navType === 'mobile' && (
        <Link
          href={MainRoutes.Login}
          variant="outlineButton"
          className="w-full font-bold"
          size="lg"
          onClick={trackNavSigninClick}
        >
          Sign In
        </Link>
      )}
    </>
  )
} 